export default class DtoCalculateParameters {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
        this.computedParameterCode = obj.computedParameterCode
    }
}